import { createApp } from 'vue'
import App from './App.vue'
import Boleto from "./components/Boleto.vue";

import { createRouter, createWebHistory } from "vue-router"

const routes = [
  { path: "/", component: Boleto },
  { path: "/gen", component: Boleto }
];

const router = createRouter({
  history: createWebHistory('/gen'),
  routes
});

createApp(App)
  .use(router)
  .mount('#app')
